import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@material-ui/core';
import { Close, ExpandMore } from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';
import theme from '@components/theme';
import { useContext, useEffect, useState } from 'react';
// @ts-ignore
import Store from '@icons/store.svg';
// @ts-ignore
import Heart from '@icons/heart-wide.svg';
import { useTranslation } from '@tools/i18n';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import NewportDrawer from '@components/drawer';
import useApplicationStore from '@services/stores/ApplicationStore';
import useSessionStore from '@services/stores/SessionStore';
import { TrackingContext } from '@components/providers/tracking';
import { useRouter } from 'next/router';

interface StoresOpenState {
    [key: string]: boolean;
}

interface PhysicalStoreStockIndicatorProps {
    productAnalyticsName: string,
    stockLevels: any,
    propertyIds?: string[],
    placement?: string,
    showIcon?: boolean
}


const useStyles = makeStyles({
    physicalStoreIndicator: {
        display: 'flex',
        gap: 8,
        position: 'relative',
        textDecoration: 'underline',
        alignItems: 'center',
        cursor: 'pointer',
        color: 'inherit',
        fontSize: 'inherit',
        fontWeight: 300,
        letterSpacing: 0,
        lineHeight: 1.5,
		width: 'fit-content',

        '&:before': {
            content: "''",
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            background: 'transparent',
        },
        '&.pdp:before': {
            position: 'absolute',
            top: -2,
            left: 14,
        },
        '&.in-stock:before': {
            backgroundColor: 'rgb(78, 199, 145)',
        },
        '&.black:before': {
            backgroundColor: 'black',
        },
        '&.out-of-stock:before': {
            backgroundColor: 'red',
        },
        '&.incoming:before': {
            background: '#f4e828',
        },
        '& svg': {
            display: 'none',
            color: '#222',
            strokeWidth: 2.5,
            width: 20,
            marginRight: 2,
        },
        '&.icon svg': {
            display: 'block',
        },
        '&.selectedStore': {
            textDecoration: 'none',
        },
        '&.list': {
            textDecoration: 'none',
            '&:before': {
                backgroundColor: 'rgb(78, 199, 145)',
            },
        }
    },
    stockPopupTitle: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        margin: '20px 0 30px',
        fontSize: 19,
        fontWeight: 400,
        textTransform: 'uppercase',
        '& svg': {
            width: 28,
            height: 28
        }
    },
    store: {
        fontSize: 14,
        // @ts-ignore
        [theme.breakpoints.up('md')]: {
            fontSize: 15
        },
        fontWeight: 400,
    },
    stockIndicator: {
        display: 'flex',
        alignItems: 'center',
        marginTop: 4,
        fontWeight: 300,
        fontSize: 14,
        // @ts-ignore
        [theme.breakpoints.up('md')]: {
            display: 'flex',
            maxWidth: 'unset',
            fontSize: 15
        },
        '&:before': {
            display: 'block',
            content: '""',
            width: 7,
            height: 7,
            marginRight: 6,
            backgroundColor: '#2ab382',
            borderRadius: '50%'
        },
        '&.almost-out-of-stock:before': {
            backgroundColor: '#ddd228'
        },
        '&.out-of-stock:before': {
            backgroundColor: '#d50025'
        },
    },
    orderToStock: {
        color: '#ddd228'
    },
    singleStoreButtonsWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        width: '100%',
        gap: 20,
        margin: '0 0 30px',
        position: 'relative',
        flexDirection: 'row-reverse',
        //@ts-ignore
        [theme.breakpoints.down('sm')]: {
            paddingRight: 5,
        },
        paddingBottom: 20,
        borderBottom: '1px solid #eee'
    },
    storeButton: {
        width: 40,
        height: 40,
        borderRadius: '3px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: '1px solid #222',
        background: 'transparent',
        padding: 5,
        color: '#222',
        flexShrink: 0,
        position: 'relative',
        fontSize: 17,
        textTransform: 'uppercase',
        transition: 'ease 0.2s',
        //@ts-ignore
        [theme.breakpoints.down('sm')]: {
            position: 'absolute',
            top: 0,
            right: 0,
            zIndex: 5,
        },
        '& svg': {
            fill: '#fff',
            margin: 'auto',
            color: '#222',
            strokeWidth: 2.5,
            width: '86%'
        },
        '& i': {
            borderRadius: '50%',
            lineHeight: 1,
            width: 20,
            height: 20,
            position: 'absolute',
            top: -4,
            right: -10.2,
            padding: '0 2px',
            background: 'transparent',
            '& svg': {
                strokeWidth: 0.75,
                color: '#222',
                fill: "#fff"
            },
        },

        '&.selectedStore': {
            background: theme.palette.primary.main,
            color: '#fff',
            '& svg': {
                fill: '#eee',
            },
            '& i svg': {
                fill: '#ff4f4f',
                color: '#ff4f4f',
            },
        }
    },
    accordion: {
        width: '100%',
        boxShadow: 'none',
        '&:before': {
            display: 'none'
        },
        // @ts-ignore
        [theme.breakpoints.down('sm')]: {
            backgroundColor: theme.palette.primary.background
        }
    },
    accordionExpanded: {
        margin: '0 0 25px 0 !important'
    },
    showMoreInfoSpan: {
        marginTop: 7,
        fontSize: 14,
        // @ts-ignore
        [theme.breakpoints.up('md')]: {
            fontSize: 15
        },
        fontWeight: 300,
    },
    value: {
        // @ts-ignore
        [theme.breakpoints.down('sm')]: {
            paddingBottom: 60
        }
    },
    summary: {
        alignItems: 'flex-start',
        margin: '0 !important',
        padding: '0',
        flexDirection: 'row-reverse',
        // @ts-ignore
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
            minHeight: '0 !important',
            marginBottom: '0 !important'
        }
    },
    summaryIcon: {
        padding: 0,
        margin: 0,
        color: '#000000',
        // @ts-ignore
        [theme.breakpoints.up('sm')]: {
            marginLeft: 0,
            margin: 0,
        }
    },
    summaryContent: {
        display: 'flex',
        flexDirection: 'column',
        margin: 0,
        padding: 0,
        gap: 2,
    },
    detailsRoot: {
        padding: 0
    },
    detailsText: {
        display: 'flex',
        gap: 20,
        width: '100%',
        fontSize: 14,
        // @ts-ignore
        [theme.breakpoints.up('md')]: {
            fontSize: 15
        },
        fontWeight: 300,
        '& > *': {
            width: '50%'
        },
        '& a': {
            color: 'inherit'
        },
    },
    disclaimer: {
        marginTop: 20,
        marginLeft: 'auto',
        textAlign: 'right',
        fontWeight: 300,
        fontStyle: 'italic',
        fontSize: 14,
        // @ts-ignore
        [theme.breakpoints.up('md')]: {
            fontSize: 15
        },
    },
}, { name: 'physical-store-quantity' });
export default function PhysicalStoreStockIndicator({productAnalyticsName, stockLevels, propertyIds=[], placement='pdp', showIcon=false}:PhysicalStoreStockIndicatorProps) {
    const classes = useStyles();
    const sessionMethods = useSessionStore((state) => state.methods);
    const appMethods = useApplicationStore((state) => state.methods);
    const preferredPhysicalStore = useSessionStore(state => state.session.preferredPhysicalStore);
    const stores = useApplicationStore(state => state.physicalStores);
    const { actions: trackingActions } = useContext(TrackingContext);
    const [stockPopup, setStockPopup] = useState(false);
    const [storesOpen, setStoresOpen] = useState<StoresOpenState>({});
    const [selectedStoreStock, setSelectedStoreStock] = useState('');
    const [selectedStoreLabel, setSelectedStoreLabel] = useState('');
    const [showComponent, setShowComponent] = useState(false)
    // @ts-ignore
    const drawerBottom = useMediaQuery(theme.breakpoints.down('sm'));
    const { t } = useTranslation(['general', 'popup', 'product-info', 'attributes']);
    const [isInAnyStock, setIsAnyInStock] = useState(false);


    useEffect(() => {
        setIsAnyInStock(appMethods.hasInPhysicalStoreLabel(propertyIds));
    }, [stores, propertyIds])

    useEffect(() => {

        if (placement === 'plp') {
            if (isInAnyStock) {
                setShowComponent(true)
            }
        }

        if (placement === 'pdp') {
            setShowComponent(true);
            if (preferredPhysicalStore && stockLevels) {
                const storeCode = stores[preferredPhysicalStore]?.code
                if (stockLevels[storeCode] >= 3) {
                    setSelectedStoreStock('in-stock');
                    setSelectedStoreLabel(t('product-info:physical-store-stock-indicator-selected-in-stock', { stockQuantity: stockLevels[storeCode], storeName: stores[preferredPhysicalStore]?.name }) );
                } else if (stockLevels[storeCode] > 0 && stockLevels[storeCode] < 3) {
                    setSelectedStoreStock('incoming');
                    setSelectedStoreLabel(t('product-info:physical-store-stock-indicator-selected-in-stock', { stockQuantity: stockLevels[storeCode], storeName: stores[preferredPhysicalStore]?.name }) );
                } else if (stockLevels[storeCode] === 0 || !stockLevels[storeCode]) {
                    setSelectedStoreStock('out-of-stock');
                    setSelectedStoreLabel(t('product-info:physical-store-stock-indicator-selected-out-of-stock', { storeName: stores[preferredPhysicalStore]?.name }) );
                }
            } else if (isInAnyStock) {
                setSelectedStoreStock('in-stock');
                setSelectedStoreLabel('');
            } else {
                setSelectedStoreStock('out-of-stock');
                setSelectedStoreLabel(t('product-info:physical-store-stock-indicator-pdp-label-out-of-stock') );

            }
        }
    }, [showComponent, stockLevels, isInAnyStock, stores, preferredPhysicalStore]);


    function renderLabel() {

        if (placement === 'plp') {
            if (preferredPhysicalStore === '' && isInAnyStock) {
                return t('product-info:choose-preferred-store-plp');
            }
            if (preferredPhysicalStore !== '' && propertyIds.includes(preferredPhysicalStore)) {
               return `${stores[preferredPhysicalStore]?.name}`
            }

           setShowComponent(false)
        }

        return selectedStoreLabel !== '' ? selectedStoreLabel : t('product-info:choose-preferred-store-pdp')
    }

    return (
        showComponent &&
            <>
                <span
                    className={`
                        ${classes.physicalStoreIndicator}
                        ${selectedStoreStock} ${showIcon ? 'icon' : ''} 
                        ${preferredPhysicalStore !== '' ? 'selectedStore' : ''} 
                        ${isInAnyStock ? 'in-stock' : ''} 
                        ${placement === 'plp' ? 'list' : 'pdp'} 
                    `}
                    onClick={() => {
                        if (placement === 'pdp') {
                           setStockPopup(true);
                            trackingActions.click({
                                type: 'product_store_stock',
                                text: 'open',
                                identifier: productAnalyticsName,
                            });
                        }
                    }}
                >
                    <Store />
                    { renderLabel() }
                </span>

                {placement === 'pdp' &&
                    <NewportDrawer
                        anchor={drawerBottom ? 'bottom' : 'right'}
                        open={stockPopup}
                        close={() => { setStockPopup(false); }}
                        title={''}
                        showClose={true}
                    >
                        <label className={classes.stockPopupTitle}>
                            {t('attributes:store_stock')}
                        </label>
                        <div className={classes.value}>
                            {Object.keys(stores)
                                .sort((storeA, storeB) => {
                                    // @ts-ignore
                                    let stockLevelA = stockLevels[storeA] || 0;
                                    // @ts-ignore
                                    let stockLevelB = stockLevels[storeB] || 0;

                                    if (stockLevelB > stockLevelA) {
                                        return 1;
                                    } else if (stockLevelA === stockLevelB) {
                                        return 0;
                                    } else {
                                        return -1;
                                    }
                                })
                                .map(storeKey => {
                                    // @ts-ignore
                                    let stockLevel = stockLevels[stores[storeKey]?.code];
                                    let store = stores[storeKey];

                                    return (
                                        <div className={classes.singleStoreButtonsWrapper} key={storeKey}>
                                            <button
                                                aria-label={t('product-info:choose-preferred-store-favorite-label')}
                                                className={[
                                                    classes.storeButton,
                                                    preferredPhysicalStore === storeKey ? 'selectedStore' : '',
                                                ].join(' ')}
                                                onClick={() => {
                                                    if (storeKey === preferredPhysicalStore) {
                                                        sessionMethods.setPreferredPhysicalStore('');
                                                    } else {
                                                        sessionMethods.setPreferredPhysicalStore(storeKey);
                                                    }
                                                }}
                                            >
                                                <Store />
                                                <i>
                                                    <Heart />
                                                </i>
                                            </button>
                                            <Accordion
                                                key={storeKey}
                                                classes={{
                                                    root: classes.accordion,
                                                    expanded: classes.accordionExpanded,
                                                }}
                                                square={true}
                                                expanded={storesOpen[storeKey]}
                                                onChange={() => {
                                                    let newStoresOpen = { ...storesOpen };

                                                    if (newStoresOpen[storeKey]) {
                                                        newStoresOpen[storeKey] = !newStoresOpen[storeKey];
                                                    } else {
                                                        newStoresOpen[storeKey] = true;
                                                    }

                                                    setStoresOpen({ ...newStoresOpen });
                                                }}
                                            >
                                                <AccordionSummary
                                                    classes={{
                                                        root: classes.summary,
                                                        content: classes.summaryContent,
                                                        expanded: classes.summary,
                                                        expandIcon: classes.summaryIcon,
                                                    }}
                                                >
                                                    <Typography className={classes.store} variant="body1">
                                                        {store.name}

                                                        {stockLevel > 10 && (
                                                            <span
                                                                className={[classes.stockIndicator, 'in-stock'].join(
                                                                    ' ',
                                                                )}
                                                            >
                                                                {t(
                                                                    'product-info:physical-store-stock-indicator-popup-label-in-stock',
                                                                    { stockLevel: '10+' },
                                                                )}
                                                            </span>
                                                        )}
                                                        {stockLevel <= 10 && stockLevel > 2 && (
                                                            <span
                                                                className={[classes.stockIndicator, 'in-stock'].join(
                                                                    ' ',
                                                                )}
                                                            >
                                                                {t(
                                                                    'product-info:physical-store-stock-indicator-popup-label-in-stock',
                                                                    { stockLevel },
                                                                )}
                                                            </span>
                                                        )}

                                                        {stockLevel <= 2 && stockLevel > 0 && (
                                                            <span
                                                                className={[
                                                                    classes.stockIndicator,
                                                                    'almost-out-of-stock',
                                                                ].join(' ')}
                                                            >
                                                                {t(
                                                                    'product-info:physical-store-stock-indicator-popup-label-few-left',
                                                                )}
                                                            </span>
                                                        )}

                                                        {(!stockLevel || stockLevel <= 0) && (
                                                            <span
                                                                className={[
                                                                    classes.stockIndicator,
                                                                    'out-of-stock',
                                                                ].join(' ')}
                                                            >
                                                                {t(
                                                                    'product-info:physical-store-stock-indicator-popup-label-out-of-stock',
                                                                )}
                                                            </span>
                                                        )}
                                                    </Typography>
                                                    <Typography className={classes.showMoreInfoSpan}>
                                                        {t(
                                                            'product-info:physical-store-stock-indicator-popup-label-show-more',
                                                        )}
                                                    </Typography>
                                                </AccordionSummary>
                                                <AccordionDetails classes={{ root: classes.detailsRoot }}>
                                                    <div className={classes.detailsText}>
                                                        <div>
                                                            <p dangerouslySetInnerHTML={{ __html: store.address }} />
                                                            <div className={'phone'}>
                                                                <a
                                                                    href={
                                                                        'tel:' +
                                                                        store?.phone
                                                                            ?.replace(/\s/g, '')
                                                                            .replace('-', '')
                                                                    }
                                                                >
                                                                    {store.phone}
                                                                </a>
                                                            </div>
                                                            <div className={'email'}>
                                                                <a href={'mailto:' + store.email}>{store.email}</a>
                                                            </div>
                                                        </div>
                                                        <p dangerouslySetInnerHTML={{ __html: store.openingHours }} />
                                                    </div>
                                                </AccordionDetails>
                                            </Accordion>
                                        </div>
                                    );
                                })}
                            <Typography className={classes.disclaimer}>{t('attributes:store_stock_disclaimer')}</Typography>
                        </div>
                    </NewportDrawer>
                }
            </>
    );

}

